<template>
  <div class="ma-0 ma-sm-4">
    <div class="mt-2 d-flex flex-row align-center">
      <div class="text-h4 mr-8">Diabetic Retinopathy</div>
      <router-link to="/icd10/diabetic-retinopathy-widget">
        <v-card color="#ffd5e3" flat class="py-2 px-4">
          Find diabetic retinopathy codes faster with the
          <span class="linkLike">Diabetic Retinopathy Widget!</span>
        </v-card></router-link
      >
    </div>
    <div class="my-4">
      <v-card color="#e9f2f5" class="pa-2 text-h5 ma-2" flat
        >Diabetes Without Complications
      </v-card>
      <div class="pa-2 ml-4">
        <div>
          <span class="codeClass">E08.9</span> Diabetes mellitus due to
          underlying condition without complications
        </div>
        <div>
          <span class="codeClass">E09.9</span> Drug or chemical induced diabetes
          mellitus without complications
        </div>
        <div>
          <span class="codeClass">E10.9</span>
          <span class="highlight"
            >Type 1 diabetes mellitus without complications</span
          >
        </div>
        <div>
          <span class="codeClass">E11.9</span>
          <span class="highlight"
            >Type 2 diabetes mellitus without complications</span
          >
        </div>

        <div>
          <span class="codeClass">E13.9</span> Other specified diabetes mellitus
          without complications
        </div>
      </div>
    </div>

    <div v-for="(data, index) in allDataByCode" :key="index" class="mt-6">
      <div v-if="data.codes">
        <icd-header
          v-if="data.meta.searchObj"
          :meta="data.meta"
          :codes="data.codes"
        ></icd-header>
        <icd-tree-element
          :meta="data.meta"
          :codes="data.codes"
          :tree="data.meta.tree"
        ></icd-tree-element>
      </div>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";

export default {
  components: {
    IcdTreeElement: () => import("@/components/icdStuff/IcdTreeElement"),
    IcdHeader: () => import("@/components/icdStuff/IcdHeader"),
  },
  name: "DiabetesGroup",
  props: {},
  data: function () {
    return {
      page: null,
      diabeticCodes: ["E11.3", "E10.3", "E08.3", "E09.3", "E13.3"],
      codesToGet: ["E11.3", "E10.3", "E08.3", "E09.3", "E13.3"],
      combinedData: [],
    };
  },
  methods: {
    // setResultForCode(aCode, result) {
    //   console.log(aCode, result);

    // },
    callApi(aCode) {
      ApiServices.codeDetails(aCode)
        .then((response) => {
          // console.log(response.data);
          let obj = {};
          obj.codes = response.data.results;
          obj.meta = response.data.meta;
          obj.loading = false;
          obj.error = false;
          obj.title = response.data.meta["title"];
          this.combinedData.push(obj);
        })
        .catch((error) => {
          console.log("api error for code " + aCode, error);
        });
    },
  },
  computed: {
    allDataByCode: function () {
      let rtn = [];
      for (const code of this.codesToGet) {
        for (const data of this.combinedData) {
          let dataCode = data?.meta?.searchObj;
          if (dataCode == code) rtn.push(data);
        }
      }
      return rtn;
    },
  },
  mounted: function () {
    // this.codesToGet = this.diabeticCodes;
    // console.log(page);
    for (const aCode of this.diabeticCodes) {
      this.callApi(aCode);
    }
  },
};
</script>

<style scoped>
.highlight {
  background-color: #ffffa6;
  padding: 1px 3px;
  border-radius: 3px;
}
.codeClass {
  font-weight: bold;
  margin-right: 0.5em;
}
</style>
